//外链热点操作
function openNavigation(data) {
  if (!data || JSON.stringify(data) == '[]' || JSON.stringify(data) == '{}') return;
  var url = '/navigation?lat='+data.lat+'&lng='+data.lng+'&title='+document.title+'&addr='+data.province+data.city+data.district+data.address;
  window.open(url);
}

export default {
  openNavigation,
};
